/** @format */

import dynamic from "next/dynamic";
import { Layout } from "../components/common/Layout";
const TermsAndConditions = dynamic(() =>
  import("../components/TermsAndConditions/TermsAndConditions")
);

export default function TermsOfUse() {
  const meta = {
    title:
      "Qalara | Global sourcing & wholesale | Verified suppliers from India",
    description:
      "Join the community of wholesale buyers from UK, Canada, USA, Australia, Europe etc and sellers on Qalara - global sourcing platform for Indian handmade products",
    url: "/TermsOfUse/",
  };

  return (
    <Layout meta={meta}>
      <TermsAndConditions />
    </Layout>
  );
}
